import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const SloganSection = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className={`relative z-0 py-20 bg-gradient-to-br from-[#005bbb] to-[#0077dd] overflow-hidden fade-in-up ${
        isVisible ? 'visible' : ''
      }`}
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="pp-container relative z-10">
        <div className="text-center">
          <div className="space-y-4">
            <h2 className="text-5xl md:text-7xl font-bold text-white leading-tight">
              <span className="block">کیفیت،</span>
              <span className="block mt-2">اعتماد،</span>
              <span className="block mt-2 text-6xl md:text-8xl">تخصص</span>
            </h2>
            <p className="text-xl md:text-2xl text-white/90 mt-8 max-w-3xl mx-auto">
              بیش از ۱۵ سال تجربه در تامین تجهیزات صنعتی
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SloganSection;
